import {
    RemoveCell,
    RemoveCellProps,
} from 'components/common/RemoveCell/RemoveCell';
import { Close } from '@mui/icons-material';
import {
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
} from '@mui/material';
import { BaseModal } from 'components/modals/BaseModal/BaseModal';
import styles from './RemovePersonCell.module.scss';
import { useState } from 'react';

interface RemovePersonCellProps extends RemoveCellProps {
    userEmail: string;
}

export function RemovePersonCell({
    onClick,
    isDisabled,
    userEmail,
}: RemovePersonCellProps) {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <RemoveCell
                onClick={() => setModalOpen(true)}
                isDisabled={isDisabled}
            />
            <BaseModal
                data-testid="DeletionDialog"
                maxWidth="xs"
                open={modalOpen}
                onClose={() => setModalOpen(false)}
            >
                <Box className={styles.modalHeader}>
                    <DialogTitle>Confirmation of Deletion</DialogTitle>
                    <Box>
                        <IconButton
                            color="inherit"
                            onClick={() => setModalOpen(false)}
                        >
                            <Close />
                        </IconButton>
                    </Box>
                </Box>
                <DialogContent>
                    <Typography variant="subtitle1">
                        Delete following user?
                    </Typography>
                    <Typography variant="subtitle2">{userEmail}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="inherit"
                        onClick={() => setModalOpen(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => onClick()}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </BaseModal>
        </>
    );
}
